import React, { FC } from 'react';
import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';

import TextCounter from './TextCounter';

interface IProps {
  required?: boolean;
}

const useStyles = makeStyles(theme => ({
  input: {
    color: theme.palette.primary.main,
    '&::-webkit-input-placeholder': {
      opacity: 1,
    },
    '&::-moz-placeholder': {
      opacity: 1,
    },
    '&:-ms-input-placeholder': {
      opacity: 1,
    },
    '&::-ms-input-placeholder': {
      opacity: 1,
    },
  },
  inputField: {
    marginBottom: theme.spacing(2),
  },
}));

const TitleTextField: FC<IProps> = ({ required }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [field] = useField('content_object.title');

  return (
    <TextField
      fullWidth
      value={field.value}
      variant="outlined"
      placeholder={t('common:title')}
      className={classes.inputField}
      inputProps={{ name: field.name }}
      onChange={field.onChange}
      InputProps={{
        endAdornment: <TextCounter length={field.value.length} limit={250} />,
        classes: required && !field.value ? { input: classes.input } : {},
      }}
    />
  );
};

TitleTextField.defaultProps = {
  required: false,
};

export default TitleTextField;
